/**
 * Some constants used in style and layout throughout the auth package.
 */
export default {
    // The max width of _Screen components inside a ProgressShell. In
    // desktop sizes, a ProgressShell can show up to two _Screen components
    // side-by-side, the max width of each is bound by this constant.
    MAX_SCREEN_WIDTH: 534,

    // A tiny amount of time to wait before applying opacity transitions. This
    // allows the visibility of content that should be shown to be set to true
    // before we start the animations. (Setting visibility: "hidden" on
    // elements whose opacity is 0 prevents them from being focused upon
    // through tabbing).
    TRANSITION_DELAY: "1ms",

    // Top margin for shell at different screen sizes.
    XL_MARGIN_TOP: 80,

    LG_MARGIN_TOP: 64,
    MOBILE_MARGIN_TOP: 40,

    // Detail screen: max left- and right-padding on xl sizes.
    XL_MAX_H_PADDING: 100,

    // Detail screen: min left- and right-padding on lg sizes.
    LG_MIN_H_PADDING: 48,

    // Min left- and right-padding on xs sizes.
    XS_MIN_H_PADDING: 24,

    // Detail screen: horizontal and vertical spacing for md or smaller sizes.
    // This is used to give the screen's vertical scrollbars (if the content
    // overflows) some from the text and the borders of the detail screen.
    MD_H_PADDING: 8,

    MD_V_MARGIN: 16,

    // Action screen form width.
    FORM_WIDTH: 368,

    // Min height of the divs below input form fields. Gives enough space
    // for 1 line of error messages or warnings to be shown under each
    // input field.
    FIELD_REQ_HEIGHT: 22,

    HEADING_FONT_SIZE_XL: 35,
    HEADING_FONT_SIZE: 23,
    SUBHEADING_FONT_SIZE: 17,
    BODY_FONT_SIZE: 15,
};
